/* eslint-disable @typescript-eslint/naming-convention */
import md5 from 'js-md5';

const TGLogURL = `https://hok-web-http.tlog.iegcom.com:29134/29134/report/`;

/**
 * decrypto 解密程序
 * @param {Strng} str 待加密字符串
 * @param {Number} xor 异或值
 * @param {Number} hex 加密后的进制数
 * @return {Strng} 加密后的字符串
 */
function decrypto(str, xor, hex) {
  if (typeof str !== 'string' || typeof xor !== 'number' || typeof hex !== 'number') {
    return;
  }
  let strCharList: any[] = [];
  const resultList: any[] = [];
  hex = hex <= 25 ? hex : hex % 25;
  // 解析出分割字符
  const splitStr = String.fromCodePoint(hex + 97);
  // 分割出加密字符串的加密后的每个字符
  strCharList = str.split(splitStr);

  for (const element of strCharList) {
    // 将加密后的每个字符转成加密后的ascll码
    let charCode = Number.parseInt(element, hex);
    // 异或解密出原字符的ascll码
    charCode = (charCode * 1) ^ xor;
    const strChar = String.fromCodePoint(charCode);
    resultList.push(strChar);
  }
  return resultList.join('');
}

const decryptoKey = decrypto('313e1013e1000e1012e1003e1001e1022e1221e301e1102e1113e1011', 4, 4);

/**
 * 处理原始数据，生成tglog所需参数
 */
export const tglog = (originData) => {
  const title = {
    app_id: '29134',
    app_name: 'hok_web',
    timestamp: Math.floor(Date.now() / 1000).toString(),
    seq_id: getSedId(),
    retry_times: '3',
  };

  const eventArray = originData.events.map((event) => {
    // 数据转换，|，&，=这三个符号需要被转义
    const ftime = '';
    const extinfo = '';
    const country = '';
    const province = '';
    const operator = '';
    const apn = '';
    const gw = '';
    const src_ip_head = '';
    const info_str = 'INFO';
    const product_id = originData?.mainAppKey || '';
    const app_version = originData?.appVersion || '';
    const sdk_id = originData?.sdkId || '';
    const sdk_version = originData?.sdkVersion || '';
    const hardware_os = '';
    const qua = '';
    const upload_ip = '';
    const client_ip = '';
    const upload_apn = '';
    const event_code = event.eventCode || '';
    const event_result = 'false';
    const package_size = 0;
    const consume_time = 0;
    const event_time = event.eventTime || '';
    const upload_time = event.eventTime || '';

    // event_value数据汇总
    const prime_event_value = {
      ...originData?.common,
      ...event.mapValue,
    };

    const event_value = encodeURIComponent(strinify(prime_event_value));

    const primeData = {
      ftime,
      extinfo,
      country,
      province,
      operator,
      apn,
      gw,
      src_ip_head,
      info_str,
      product_id,
      app_version,
      sdk_id,
      sdk_version,
      hardware_os,
      qua,
      upload_ip,
      client_ip,
      upload_apn,
      event_code,
      event_result,
      package_size,
      consume_time,
      event_time,
      upload_time,
      event_value,
    };

    return {
      log_name: 'CampWebOversea',
      log_fields: strinify(primeData),
    };
  });

  const data = eventArray;

  const signature = md5(
    `${JSON.stringify({
      title,
      data,
    })}${decryptoKey}`,
  );

  const headers = {
    'Content-Type': ' application/json',
    signature,
    version: '1.0',
  };

  return {
    url: TGLogURL,
    headers,
    body: {
      title,
      data,
    },
  };
};

// timeStamp加随机4位数
const getSedId = () => Date.now().toString() + Math.floor(Math.random() * 10_000).toString();

// strinify object
const strinify = (obj) => {
  const arr: string[] = [];
  for (const [key, value] of Object.entries(obj)) {
    arr.push(`${key}=${value}`);
  }
  return arr.join('&');
};
